import { BendDirection, BendOrientation } from '../__generated/model/index.js';
/** Rotate a flat-plate vector into the plane of the arm after a 90-degree bend. */ export const rotateVectorOntoBentArm = (vector, orientation, direction)=>{
    const armDirection = direction === BendDirection.Front ? -1 : 1;
    if (orientation === BendOrientation.Horizontal) {
        return {
            x: vector.x,
            y: -armDirection * vector.z,
            z: armDirection * vector.y
        };
    }
    return {
        x: -armDirection * vector.z,
        y: vector.y,
        z: armDirection * vector.x
    };
};

//# sourceMappingURL=bend-vector.js.map